webpackJsonp([5],{

/***/ 493:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['lastOrder'],
  data: function data() {
    return {
      err: '',
      headers: [{ text: this.$lang.header.srNo, value: 'index', align: 'left', sortable: false }, { text: this.$lang.header.historyId, value: 'historyId', align: 'left', sortable: false }, { text: this.$lang.header.system, value: 'system', align: 'left', sortable: false }, { text: this.$lang.labels.created, value: 'createdOn', align: 'left', sortable: false }, { text: this.$lang.labels.status, value: 'status', align: 'left', sortable: false }],
      trackingHistory: []
    };
  },

  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm');
    }
  },
  created: function created() {
    var _this = this;

    this.$http.get('webshoporder/trackinghistory/' + this.lastOrder.id).then(function (res) {
      if (res.body.status === 'Success') {
        _this.trackingHistory = res.body.trackingHistory;
        return;
      }
      _this.err = res.body.statusText;
    }, function (err) {
      _this.err = err.body.statusText || err.body.message;
    });
  }
});

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(451)(true);
// imports


// module
exports.push([module.i, ".last-order-modal[data-v-55b2683f]{font-size:22px}.close-btn[data-v-55b2683f]{right:10px;top:10px}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/modals/LastOrderModal.vue"],"names":[],"mappings":"AACA,mCACE,cAAgB,CACjB,AACD,4BACE,WAAY,AACZ,QAAU,CACX","file":"LastOrderModal.vue","sourcesContent":["\n.last-order-modal[data-v-55b2683f] {\n  font-size: 22px;\n}\n.close-btn[data-v-55b2683f] {\n  right: 10px;\n  top: 10px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(524);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(452)("775734c7", content, true, {});

/***/ }),

/***/ 582:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-btn', {
    staticClass: "close-btn",
    attrs: {
      "absolute": "",
      "flat": "",
      "fab": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('v-flex', {
    staticClass: "last-order-modal",
    attrs: {
      "xs12": "",
      "text-xs-center": "",
      "py-3": ""
    }
  }, [_vm._v("\n    Order History #\n    (" + _vm._s(_vm.lastOrder.short ? _vm.lastOrder.short : _vm.lastOrder.id) + ")\n  ")]), _vm._v(" "), (_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.trackingHistory
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.historyId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.system))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(props.item.createdOn)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))])]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(550)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(582),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-55b2683f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/5.88e07d48cabc1af089f8.js